module.exports = __webpack_public_path__ + "static/img/lucre-games-geotap-game-casual-relaxing-low=poly-design-game-cards.315cc89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lucre-games-geotap-game-casual-relaxing-low=poly-design-game-cards.png
// module id = Pu3T
// module chunks = 0